import styled from 'styled-components'

export const Container = styled.div`
  background-color: #181b25;
  width: 100vw;
  min-height: 100vh;
  height: 100%;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.9);
`

export const BackButtonNavbar = styled.div`
  background-color: white;
  display: flex;
  align-items: center;
  height: 56px;
  gap: 26px;
  padding: 16px 14px;
  margin-top: 24px;
  img {
    height: 24px;
    object-fit: contain;
  }
`
export const JoinUsDiv = styled.div`
  background-color: white;
  width: 92%;
  margin: 16px auto;
  border-radius: 8px;
  padding: 24px 16px 24px 8px;
  max-width: 600px;
  h2 {
    color: rgba(13, 21, 54, 0.8);
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 8px;
    margin-left: 8px;
  }
  p {
    color: rgba(13, 21, 54, 0.65);
    font-family: Noto Sans;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    margin-bottom: 8px;
    margin-left: 8px;
  }
`

export const FlexDiv = styled.div`
  display: flex;
  align-items: center;
`
export const ContentPointDiv = styled(FlexDiv)`
  gap: 8px;
  margin: 16px 0;
  text-align: left;
`

export const ContentPointsIcon = styled.div`
  background-color: rgba(6, 138, 226, 0.16);
  border-radius: 4px;
  padding: 8px;
  height: 40px;
  width: 40px;
`
export const ContentPoint = styled.div`
  font-size: 14px;
  color: #0350a2;
  font-weight: 500;
  line-height: 20px;
  b {
    font-weight: 700;
  }
`
export const CTAHelperText = styled.div`
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  font-size: 12px;
  font-weight: ${({ lightText }) => (lightText ? '400' : '700')};
  line-height: 18px;
  width: 88%;
  max-width: 600px;
  margin: 16px auto;
`

export const RedirectButtons = styled.button`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.99);
  border-radius: 4px;
  background: ${({ highlight }) => (highlight ? '#e51a4d' : 'transparent')};
  padding: 8px;
  border: ${({ highlight }) => (highlight ? 'none' : '2px solid #2F323B')};
  outline: none;
  width: 90%;
  max-width: 600px;
  height: 48px;
  margin: 8px auto;
  display: block;
`

export const PolicyDisclaimer = styled.div`
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  width: 90%;
  margin: 12px auto;
  a {
    color: #e51a4d;
    text-decoration-line: underline;
  }
`

export const HeroBannerImg = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  img {
    width: 164px;
    object-fit: contain;
    margin: 24px 0;
  }
`

export const WelcomeText = styled.div`
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  font-size: 16px;
  font-weight: 700;
`

export const LoaderDiv = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`
